import React, { Component } from 'react';
import Masthead from '../Masthead/Masthead';
import PrimaryNav from '../PrimaryNav/PrimaryNav';
import SecondaryNav from '../SecondaryNav/SecondaryNav';
import Footer from '../Footer/Footer';
import Legal from '../Legal/Legal';

class Page extends Component {

    componentDidMount(){
        // Quick & dirty SPA focus management
        const resetFocusItem = document.getElementsByTagName("h1")[0];
        resetFocusItem.setAttribute("tabindex", "-1");
        resetFocusItem.style.outline = "none";
        resetFocusItem.focus();
    }

    render(props) {
        return (
            <div className="App">
                <Masthead />
                <PrimaryNav title={this.props.primaryTitle} />
                <SecondaryNav title={this.props.secondaryTitle} section={this.props.section} />
                <div className="page-outer">
                    <div role="main" className="container page">
                        {this.props.children}
                    </div>
                </div>
                <Footer />
                <Legal />
            </div>
        );
    }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/Page/Page.js